import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { getImagePath } from '../../utils/imagePath';

const Golf = () => {
  const [activeImage, setActiveImage] = useState(0);

  const sectionData = {
    name: 'Bonny IslandGolf Club',
    category: 'Individual Sports',
    description: 'Premium golfing experience with professional coaching.',
    longDescription: 'Experience the finest golfing at our Golf Club. With a challenging 9-hole course, practice facilities, and professional instruction, we cater to golfers of all skill levels. Join our vibrant community for weekly competitions, social events, and the pure enjoyment of the game.',
    images: [
      getImagePath('images/bars/golf.jpg'),
      getImagePath('images/bars/golf.jpg'),
      getImagePath('images/bars/golf.jpg')
    ],
    icon: 'fa-golf-ball',
    members: '65+ active members',
    coach: 'PGA Professional David Williams',
    schedule: 'Daily: 6am - 6pm',
    level: 'All Levels',
    features: [
      '9-Hole Course',
      'Driving Range',
      'Putting Green',
      'Professional Coaching',
      'Club Tournaments',
      'Handicap Tracking',
      'Golf Shop',
      'Equipment Rental'
    ],
    facilities: ['Pro Shop', 'Locker Rooms', 'Practice Area', 'Clubhouse'],
    contact: {
      phone: '+234 905 584 6379',
      email: 'golf@nlngraclub.com',
      extension: '207'
    },
    events: ['Weekly Stableford', 'Monthly Medal', 'Club Championship', 'Mixed Events'],
    lessons: ['Private Lessons', 'Group Clinics', 'Junior Golf', 'Playing Lessons']
  };

  return (
    <div className="section-detail-page">
      {/* Hero Section */}
      <section className="section-detail-hero">
        <div className="hero-background">
          <img src={sectionData.images[0]} alt={sectionData.name} />
          <div className="hero-overlay"></div>
        </div>
        <div className="container">
          <motion.div 
            className="hero-content"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <Link to="/sections" className="back-link">
              <i className="fas fa-arrow-left"></i> Back to Sections
            </Link>
            <span className="section-category">{sectionData.category}</span>
            <h1 className="section-title">{sectionData.name}</h1>
            <p className="section-subtitle">{sectionData.description}</p>
          </motion.div>
        </div>
      </section>

      {/* Section Content */}
      <section className="section-content-section">
        <div className="container">
          <div className="section-grid">
            {/* Left Column - Images */}
            <div className="section-gallery">
              <div className="main-image">
                <img 
                  src={sectionData.images[activeImage]} 
                  alt={sectionData.name} 
                />
              </div>
              <div className="image-thumbnails">
                {sectionData.images.map((img, index) => (
                  <button 
                    key={index} 
                    className={`thumbnail-btn ${activeImage === index ? 'active' : ''}`}
                    onClick={() => setActiveImage(index)}
                  >
                    <img src={img} alt={`${sectionData.name} ${index + 1}`} />
                  </button>
                ))}
              </div>
            </div>

            {/* Right Column - Details */}
            <div className="section-details">
              <div className="detail-section">
                <h2>About {sectionData.name}</h2>
                <p className="section-description">{sectionData.longDescription}</p>
              </div>

              <div className="coach-info">
                <div className="info-card">
                  <i className="fas fa-user-tie"></i>
                  <div>
                    <h4>PGA Professional</h4>
                    <p>{sectionData.coach}</p>
                  </div>
                </div>
                <div className="info-card">
                  <i className="fas fa-users"></i>
                  <div>
                    <h4>Members</h4>
                    <p>{sectionData.members}</p>
                  </div>
                </div>
                <div className="info-card">
                  <i className="fas fa-clock"></i>
                  <div>
                    <h4>Course Hours</h4>
                    <p>{sectionData.schedule}</p>
                  </div>
                </div>
              </div>

              <div className="detail-section">
                <h3>Key Features</h3>
                <ul className="features-list">
                  {sectionData.features.map((feature, index) => (
                    <li key={index}>
                      <i className="fas fa-check-circle"></i>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="additional-info">
                <div className="info-row">
                  <span className="info-label">Events:</span>
                  <span className="info-value">{sectionData.events.join(' • ')}</span>
                </div>
                <div className="info-row">
                  <span className="info-label">Lessons:</span>
                  <span className="info-value">{sectionData.lessons.join(' • ')}</span>
                </div>
              </div>

              <div className="action-buttons">
                <Link to="/login" className="btn btn-primary btn-large">
                  <i className="fas fa-handshake"></i> Join This Section
                </Link>
                <Link to="/reservation" className="btn btn-outline btn-large">
                  <i className="fas fa-calendar"></i> Book Tee Time
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Golf;